<template>
  <div id="consultarAvisosWrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Avisos" :botoes="botoesHeader" breakpoint="md" />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form @submit.stop.prevent="filtrarAvisos" @reset.prevent="limparFiltros">
            <b-row>
              <b-col cols="12" md="6" xl="4">
                <b-form-group id="input-group-filtroTitulo" label="Título" label-for="input-filtroTitulo"
                label-class="text-left">
                  <b-form-input id="input-filtroTitulo" v-model="filtro.titulo" type="text" />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" xl="4">
                <b-form-group id="input-group-filtroMensagem" label="Mensagem" label-for="input-filtroMensagem"
                  label-class="text-left">
                  <b-form-input id="input-filtroMensagem" v-model="filtro.mensagem" type="text" />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" xl="4">
                <b-form-group id="input-group-filtroUsuario" label="Usuário que criou" label-for="input-filtroUsuario"
                  label-class="text-left">
                  <input-busca-usuario v-model="filtro.usuarioCriador" />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" xl="4">
                <b-form-group id="input-group-filtroUsuarioDestinatario" label="Usuário destinatário (nome ou CPF)"
                  label-for="input-filtroUsuarioDestinatario" label-class="text-left">
                  <input-busca-usuario v-model="filtro.usuarioDestinatario" />
                </b-form-group>
              </b-col>
              <b-col id="input-group-filtroUg" cols="12" xl="4">
                <span class="d-block text-left pb-1">Unidade Gestora</span>
                <multiselect v-model="filtro.ug" open-direction="bottom" :close-on-select="true" :searchable="true"
                  deselect-label="" :allow-empty="true" placeholder="Selecione uma UG" track-by="IdPCM" :options="ugs"
                  label="Nome" :show-labels="false" class="wrapper-multiselect-sagres">
                  <template slot="noOptions">
                    <small><i>Erro ao obter dados.</i></small>
                  </template>
                  <template slot="noResult">
                    <i>Sem resultados.</i>
                  </template>
                </multiselect>
              </b-col>
              <b-col cols="12" xl="4">
                <b-form-group id="input-group-filtroTipoUg" label="Tipo de UG" label-for="input-filtroTipoUg"
                  label-class="text-left">
                  <b-form-select id="input-filtroTipoUg" v-model="filtro.tipoUg" :options="tiposUg"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="4">
                <b-form-group
                  id="input-group-filtroTipoAviso"
                  label="Tipo de Aviso"
                  label-for="input-filtroTipoAviso"
                  label-class="text-left">
                  <b-form-select
                    id="input-filtroTipoAviso"
                    v-model="filtro.tipoAviso"
                    :options="tiposAviso"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="12" xl="4">
                <b-form-group id="input-group-dtinicio" label-size="md" label="Data inicial">
                  <b-form-datepicker id="input-data-inicio" v-model="filtro.dataInicio" v-bind="datePickerProps" />
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="4">
                <b-form-group id="input-group-dtfim" label-size="md" label="Data final">
                  <b-form-datepicker id="input-data-fim" v-model="filtro.dataFim" v-bind="datePickerProps" />
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pt-4 d-flex justify-content-center">
                <b-button size="sm" variant="outline-secondary" class="mr-2" type="reset">
                  <font-awesome-icon icon="redo" class="mr-2" />
                  Limpar Filtros
                </b-button>
                <b-button size="sm" variant="outline-secondary" type="submit">
                  <font-awesome-icon icon="filter" class="mr-2" />
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>
        <b-table
          :busy="isBusy"
          :fields="fields"
          hover
          no-border-collapse
          no-local-sorting
          :items="items"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          striped
          small
          per-page="0"
          :current-page="currentPage"
          stacked="sm"
          responsive
          show-empty
          @sort-changed="onSortChanged"
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <b-link class="text-dark" @click="visualizarAviso(row.item.Id)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Detalhes</div>
              </b-link>
              <b-link class="text-dark" @click="editarAviso(row.item.Id)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
            </div>
          </template>
        </b-table>
        <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="perPage" @pageChange="pageChange" />
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import messagesService from "@/services/messagesService";
import { fieldsConsultaAvisos } from "@/types/avisos/fields-avisos";
import { FiltrosAvisos } from "@/types/avisos/filtros-avisos";
import { BotaoSagres } from "@/types/botao-sagres";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import { SelectValue } from "@/types/select-value";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import Multiselect from "vue-multiselect";
import { Component, Vue } from "vue-property-decorator";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import InputBuscaUsuario from "@/components/shared/InputBuscaUsuario.vue";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";

const CompProps = Vue.extend({
  name: "ConsultarAvisos",
  components: {
    CardFiltrosBusca,
    HeaderSagres,
    InputBuscaUsuario,
    Multiselect,
    TablePagination,
  },
});
@Component
export default class ConsultarAvisos extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "plus",
      texto: "Novo Aviso",
      acao: this.criarAviso,
    },
  ];
  datePickerProps = DatePickerDefaultProps;
  fields: TableField[] = fieldsConsultaAvisos;
  filtro: FiltrosAvisos = new FiltrosAvisos();

  tiposUg: any[] = [];
  tiposAviso: SelectValue[] = [];
  ugs: UnidadeGestoraResumida[] = [];
  isBusy = true;
  sortBy = "DataCadastro";
  sortDesc = true;


  perPage = 10;  currentPage = 1;  totalRows: number | null = null;


  

  items: any[] = [];
  ugSelecionada: any = null;

  async onSortChanged(ctx: { sortBy: string | null; sortDesc: boolean }): Promise<void> {
    if (!ctx.sortBy) return;

    this.sortBy = ctx.sortBy;
    this.sortDesc = ctx.sortDesc;
    this.currentPage = 1;
    await this.loadData();
  }

  async pageChange(value: number): Promise<void> {
    this.isBusy = true;
    this.currentPage = value;
    await this.loadData();
  }

  criarAviso(): void {
    this.$router.push("/avisos/criar/");
  }

  visualizarAviso(id: number): void {
    this.$router.push("/avisos/" + id);
  }

  editarAviso(id: number): void {
    this.$router.push("/avisos/editar/" + id);
  }

  filtrarAvisos(): void {
    this.pageChange(1);
  }

  limparFiltros(): void {
    this.filtro.limpar();
    this.pageChange(1);
  }
  async loadData(): Promise<void> {
    try {
      this.isBusy = true;

      const response = this.filtro.estaVazio()
        ? await messagesService.getTodosAvisos(
            this.currentPage,
            this.perPage,
            this.sortBy,
            this.sortDesc ? "desc" : "asc"
          )
        : await messagesService.filtrarAvisos(
            this.currentPage,
            this.perPage,
            this.filtro,
            this.sortBy,
            this.sortDesc ? "desc" : "asc"
          );
      this.totalRows = response.totalRows;
      this.items = response.avisos;
    } catch (error: any) {
      this.items = [];
      this.tratarError(error);
    } finally {
      this.isBusy = false;
    }
  }

  async carregarTiposUg(): Promise<void> {
    try {
      const response = await messagesService.getTiposUg();

      this.tiposUg = [
        { value: null, text: "Todos" },
        ...response.data.map((t) => {
          return {
            value: t.Id,
            text: this.capitalize(t.Nome),
          };
        }),
      ];
    } catch (error: any) {
      this.tratarError(error);
    }
  }

  async carregarTiposAviso(): Promise<void> {
    try {
      const response = await messagesService.getTiposAviso();
      if (!response || response.status !== 200) {
        this.tiposAviso = [{ value: 1, text: "Padrão" }];
        this.filtro.tipoAviso = 1;
        return;
      }
      this.tiposAviso = [
        { value: null, text: "Todos" },
        ...response.data.map((t): SelectValue => {
          return {
            value: t.Id,
            text: this.capitalize(t.Descricao || t.Nome || "Sem descrição"),
          };
        }),
      ];
      this.filtro.tipoAviso = 1;
    } catch (error: any) {
      this.tiposAviso = [{ value: 1, text: "Padrão" }];
      this.filtro.tipoAviso = 1;
      this.tratarError(error);
    }
  }

  async carregarUgs(): Promise<void> {
    try {
      this.ugs = await messagesService.filtrarUgs();
    } catch (e: any) {
      this.ugs = [];
      this.tratarError(e);
    }
  }

  async mounted(): Promise<void> {
    await this.carregarUgs();
    await this.carregarTiposUg();
    await this.carregarTiposAviso();
    await this.loadData();
  }
}
</script>

<style scoped>
::v-deep div.multiselect.wrapper-multiselect-sagres {
  height: 38px;
  min-height: 38px;
}

::v-deep div.multiselect__tags {
  height: 38px;
}
</style>
